import { Project, ProjectStatus } from "datamodel/project";

const isProjectReady = (project: Project): boolean => project.status === ProjectStatus.Ready;

export default isProjectReady;
